import React, { useState } from "react";
import _ from "lodash";
import { Button, TextField } from "@mui/material";
import { VictoryPie, VictoryTooltip } from "victory";
import VictoryTheme from "ui/themes/VictoryTheme";

const fieldToMinMax = {
  S2503_C01_004E: [10000.0, 14999.0],
  S2503_C01_011E: [100000.0, 149999.0],
  S2503_C01_005E: [15000.0, 19999.0],
  S2503_C01_012E: [150000.0, 99999999.0],
  S2503_C01_006E: [20000.0, 24999.0],
  S2503_C01_007E: [25000.0, 34999.0],
  S2503_C01_008E: [35000.0, 49999.0],
  S2503_C01_003E: [5000.0, 9999.0],
  S2503_C01_009E: [50000.0, 74999.0],
  S2503_C01_010E: [75000.0, 99999.0],
  S2503_C01_002E: [0, 4999.0]
};

function RentCalculator({ tract }) {
  const tractData = JSON.parse(tract.acsS2503);
  const [rentStr, setRentStr] = useState("");
  const [rent, setRent] = useState(null);
  const median = parseFloat(tractData["S2503_C01_013E"]);
  const data = [
    { x: "Can't Afford", y: 0 },
    { x: "Can Afford", y: 0 }
  ];

  const onSubmit = e => {
    e.preventDefault();
    setRent(parseInt(rentStr));
  };

  if (rent !== null) {
    _.forEach(fieldToMinMax, ([min, max], field) => {
      // rent is monthly, min and max are annual
      // can afford it if rent is 1/3 of monthly income or less
      if (rent * 12 < min * 0.3) {
        data[1].y += parseInt(tractData[field]);
      } else if (rent * 12 <= max * 0.3) {
        // distribute the average to both
        const splitVal = Math.round(parseFloat(tractData[field]) / 2.0);
        data[0].y += splitVal;
        data[1].y += splitVal;
      } else {
        data[0].y += parseInt(tractData[field]);
      }
    });
    try {
      const total = data[0].y + data[1].y;
      data[0].pct = data[0].y / total;
      data[1].pct = data[1].y / total;
    } catch (err) {}
  }

  return (
    <div>
      <h3>Rent Calculator</h3>
      <p>
        {median.toLocaleString("en", { style: "currency", currency: "USD" })}{" "}
        Median Income
      </p>
      <form onSubmit={onSubmit}>
        <TextField
          autoFocus
          margin="dense"
          id="asking-price"
          data-testid="asking-price"
          label="Asking Price"
          type="number"
          onChange={e => setRentStr(e.target.valueAsNumber)}
          fullWidth
          value={rentStr}
        />
        <Button type="submit">Submit</Button>
      </form>
      {rent && (
        <VictoryPie
          theme={VictoryTheme}
          labelComponent={<VictoryTooltip />}
          data={data}
          labels={({ datum }) =>
            `${datum.x}\n${datum.y} households\n(${datum.pct.toLocaleString(
              "en",
              {
                style: "percent"
              }
            )}%)`
          }
        />
      )}
    </div>
  );
}

export default RentCalculator;
